import { render } from "./CustomerSuppliers.vue?vue&type=template&id=509e484c&scoped=true"
import script from "./CustomerSuppliers.vue?vue&type=script&lang=js"
export * from "./CustomerSuppliers.vue?vue&type=script&lang=js"

import "./CustomerSuppliers.vue?vue&type=style&index=0&id=509e484c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509e484c"]])

export default __exports__